var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWaitingroom({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 133,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.209 54.489h-62.998V5.249h62.998v49.24z",
    fill: "#DCEAFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.9 54.488h-1.689V5.248h1.689v49.24z",
    fill: "#CADFF8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.179 52.316h-57.447V7.421h57.447v44.895z",
    fill: "#F9FBFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.775 10.47h-50.52v38.858h50.52V10.47zm-48.347 36.685V12.64h46.176v34.514h-46.176z",
    fill: "#DCEAFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.459 39.38h-24.132V20.417h24.132v18.961z",
    fill: "#CADFF8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.94 67.105h-28.683V35.42h28.683v31.685z",
    fill: "#DCEAFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.556 65.103h-24.014V37.42h24.014v27.683z",
    fill: "#F9FBFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.925 67.105h-1.668V35.42h1.668v31.685zm20.356-8.79h-12.426V44.068h12.426v14.247z",
    fill: "#CADFF8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.929 20.37c-3.168-.067-7.072 1-11.165 2.07-3.347.876-8.676-.43-11.725-.497-.817-.018-.11 2.48.711 3.605.924 1.263 2.711 1.727 2.283 2.216a23.465 23.465 0 00-5.814 14.922c-.081 3.084-3.241 4.51-5.435 4.843 1.142 3.996 6.012 2.146 6.245 2.747 3.559 9.16 12.146 16.3 21.919 16.3 12.553 0 22.73-10.696 22.73-23.89 0-11.248-10.374-22.117-19.749-22.316z",
    fill: "#7B6153"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.27 67.05c2.378 1.586 6.654.369 10.347.155l.845 10.52 12.049-4.975s-1.158-11.61-1.66-16.062c2.422-2.202 6.548-3.223 6.555-6.964 0-1.296-.754-3.538-3.541-3.545-3.74-.004-3.205 4.494-3.205 4.494a1.93 1.93 0 01-1.392.004c-3.703-.154-6.483.983-13.486-11.022-.817 4.041-6.464 8.018-13.567 9.902.7 5.433 2.572 14.502 7.055 17.492z",
    fill: "#E2BEAB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.795 54.43c-.094-1.07-1.517-1.367-2.032-.426l-1.12 2.042c-.4.73.136 1.62.968 1.607l1.299-.02a1.085 1.085 0 001.065-1.18l-.18-2.024z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.412 51.122c.066 1.199.827 2.133 1.699 2.086.872-.046 1.525-1.056 1.459-2.255-.067-1.2-.828-2.134-1.7-2.087-.872.047-1.525 1.056-1.458 2.256zm-8.19-.001c.067 1.2.828 2.134 1.7 2.087.871-.046 1.525-1.056 1.458-2.255-.067-1.2-.827-2.134-1.699-2.087-.873.047-1.526 1.056-1.459 2.255z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.402 58.504a.9.9 0 00-1.274.067c-.628.701-1.272 1.105-1.912 1.286a2.557 2.557 0 01-1.034.088l-.125-.022-.024-.005a.902.902 0 00-1.136.584.906.906 0 00.582 1.14c.072.023.176.05.311.073 1.451.259 3.142-.217 4.68-1.933a.907.907 0 00-.068-1.278z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    rx: 2.527,
    ry: 1.811,
    transform: "matrix(-1 0 0 1 128.184 55.202)",
    fill: "#E88950"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.395,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.633 66.69s5.159-.711 7.148-1.801l-6.9 4.886-.248-3.085z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.658 159.166c-.6 1.178-1.709 7.011-1.656 8.163.053 1.152 3.51 6.331 3.51 6.331 2.144-.526.743-3.2.743-3.2s1.922 1.624 2.72 1.597c7.521-.256 7.118-4.064 6.94-4.541-.399-1.071-2.407.154-2.407.154s3.86-7.832 2.93-13.311l.217.027 11.843-18.867.82-7.352 32.262-.476s-.279-3.006.408-7.35c.896-5.681 6.358-16.234 6.358-16.234l8.442 12.76 6.141 33.293-.098-.062-2.796 8.942s-.281 3.738-.331 5.938c-.05 2.199-.024 1.674-1.256 5.07-.859 2.365 2.544 1.4 3.408.047.892-1.396.902-6.817 2.67-5.89 1.768.928 2.775 6.301 2.878 11.444.017.808.672 1.043 1.118 1.239.724.318 1.434-2.557 1.434-2.557s.466 1.082 1.519.528c.373-.196 1.33-2.444 1.33-2.444s.797-1.135 1.158-2.358c.637-2.159.954-6.097.688-7.224-.631-2.666-1.912-7.155-3.27-9.57.025-.539 1.244-27.601-4.341-43.445-4.934-13.997-12.451-29.199-19.481-33.628-7.231-4.556-13.746-3.352-19.795-3.036-10.456.55-15.629.438-20.303 4.73-9.751 8.952-6.377 44.319-6.377 44.319l-12.908 31.12.15.019c-1.948 2.294-4.322 5.145-4.668 5.824z",
    fill: "#E2BEAB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.068 84.177s-6.03-10.637-6.036-10.636c-5.339.412-9.047 1.157-12.27 4.145-6.593 6.111-11.297 23.813-12.164 34.321l12.006 4.283 1.799 11.781h32.451s-.34-3.525.339-7.863c.886-5.674 4.083-9.907 4.083-9.907l3.172 4.764 19.724-11.492c-6.458-11.637-15.465-23.637-21.47-27.455-4.003-2.547-7.784-3.292-11.387-3.4-.013 0-10.247 11.46-10.247 11.46zm6.596-11.389c.215-.011.43-.023.647-.032l-.647.032z",
    fill: "#96C0F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.711 91.693v2.773c0 .554.453 1.007 1.013 1.007h7.759c.56 0 1.013-.453 1.013-1.007v-2.773h-9.785z",
    fill: "#E8EFF7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.711 90.44v1.253h9.785V90.44c0-.56-.453-1.012-1.013-1.012h-7.759c-.56 0-1.013.453-1.013 1.012z",
    fill: "#3C4C60"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M114.167 91.292a.742.742 0 00-.835.637c-1.05 7.806-.882 12.902.295 19.217l.126.662c.275 1.392.943 4.633.967 4.75l.098.489c.74 3.72 1.201 6.728 1.527 10.374a.743.743 0 101.48-.132c-.33-3.705-.8-6.762-1.548-10.53l-1.001-4.912c-.054-.27-.099-.499-.13-.663l-.115-.616c-1.097-6.022-1.237-10.924-.226-18.44a.744.744 0 00-.638-.836zm31.778 7.013a.743.743 0 00-1.268.772l.032.052 7.431 11.148a.745.745 0 001.269-.773l-.032-.052-7.432-11.147z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.1 133.556c0 4.815-52.181 8.718-116.55 8.718S0 138.371 0 133.556c0-4.815 50.345-5.268 114.713-5.268 64.369 0 118.387.453 118.387 5.268z",
    fill: "#EDF4FC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.48 132.95h36.131a3.496 3.496 0 100-6.993H186.48v6.993z",
    fill: "#5096E8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.158 129.454a3.496 3.496 0 003.497 3.496h199.3a3.497 3.497 0 100-6.993h-199.3a3.496 3.496 0 00-3.497 3.497z",
    fill: "#73ABED"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.323 58.676S27.92 88.262 26.318 120.429c0 0 7.503-32.598 15.005-61.753z",
    fill: "#90D4AA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.34 81.412s9.648.251 11.117 32.419c0 0-4.117-24.278-11.117-32.419z",
    fill: "#70C892"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.193 49.034s5.632 34.034.089 68.665c0 0 .33-36.17-.089-68.665z",
    fill: "#7FCE9E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.79 126.806H20.86c-.104 0-.208-.002-.312-.005-6.352-.238-9.885-8.272-6.288-14.068l3.191-5.141H38.2l3.19 5.141c3.598 5.796.064 13.83-6.287 14.068-.104.003-.208.005-.313.005z",
    fill: "#6F7F93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.83 118.63v1.573H12.82v-1.573h30.01zm-.599-4.969v1.574H13.518v-1.574H42.23z",
    fill: "#E1E8EF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.578 124.091a2.331 2.331 0 002.284 1.866h11.56a2.331 2.331 0 002.284-2.796l-5.46-26.807a2.331 2.331 0 00-2.285-1.866h-11.56a2.331 2.331 0 00-2.283 2.797l5.46 26.806z",
    fill: "#B0BBC8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.896 124.112a2.33 2.33 0 002.28 1.845H58.31a2.331 2.331 0 002.28-2.817l-5.714-26.807a2.331 2.331 0 00-2.28-1.845H40.464a2.331 2.331 0 00-2.28 2.817l5.713 26.807z",
    fill: "#D4DBE2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.34 122.706c.117.537.591.92 1.14.92h10.936c.742 0 1.296-.686 1.139-1.412l-5.408-25.058a1.165 1.165 0 00-1.14-.92H41.073c-.742 0-1.296.686-1.139 1.412l5.408 25.058z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.566 109.64h13.38l-2.737-12.488a1.165 1.165 0 00-1.139-.916H41.077c-.744 0-1.298.688-1.139 1.415l2.628 11.989z",
    fill: "#73ABED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.924 102.96a.443.443 0 01.077.766l-2.84 2.028a.443.443 0 01-.69-.264l-.811-3.651a.443.443 0 01.612-.501l3.652 1.622z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.453 112.554h6.993m-6.178 2.797h7.927",
    stroke: "#E8EFF7",
    strokeWidth: 1.399,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.466 109.438c0-.397-.188-.771-.507-1.007l-5.969-4.429h-4.596l-5.97 4.429c-.319.236-.507.61-.507 1.007v15.246c0 .692.562 1.253 1.254 1.253h15.041c.693 0 1.254-.561 1.254-1.253v-15.246z",
    fill: "#B9D5F6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.521,
    height: 2.925,
    rx: 0.418,
    transform: "matrix(-1 0 0 1 195.452 101.493)",
    fill: "#61A0EA"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#61A0EA",
    d: "M192.736 98.57h-2.089v2.507h2.089z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#84B5EE",
    d: "M192.736 105.049h-2.089v5.432h2.089z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.571 96.273a.835.835 0 00-.835-.835h-8.207a.418.418 0 00-.398.542l.472 1.514h4.907l.213 1.286h3.848v-2.507z",
    fill: "#B9D5F6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.041,
    height: 11.699,
    rx: 0.418,
    transform: "matrix(-1 0 0 1 199.213 111.315)",
    fill: "#F9FBFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.873 97.525l-1.708 2.814c-.809 1.332.15 3.036 1.708 3.036s2.517-1.704 1.709-3.036l-1.709-2.814z",
    fill: "#DCEAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h233v133H0z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitingroom);
export default __webpack_public_path__ + "static/media/waitingroom.1cf477c8d4d6ea48086c4f46f5218c82.svg";
export { ForwardRef as ReactComponent };